<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="23.1" height="15" viewBox="0 0 23.1 15" @click="$emit('click')" role="img" aria-label="Open menu">
        <title>Open Menu</title>
        <g transform="translate(-11.2 -10.6)">
            <path d="M11.2,12.6V11.3c0-.2.1-.3.3-.5a1.445,1.445,0,0,1,.7-.2H33.3a1.445,1.445,0,0,1,.7.2.55.55,0,0,1,.3.5v1.3c0,.2-.1.3-.3.5a1.445,1.445,0,0,1-.7.2H12.2a1.445,1.445,0,0,1-.7-.2C11.3,12.9,11.2,12.8,11.2,12.6Z"/>
            <path d="M11.2,18.7V17.4c0-.2.1-.3.3-.5a1.445,1.445,0,0,1,.7-.2H33.3a1.445,1.445,0,0,1,.7.2.55.55,0,0,1,.3.5v1.3c0,.2-.1.3-.3.5a1.445,1.445,0,0,1-.7.2H12.2a1.445,1.445,0,0,1-.7-.2A.55.55,0,0,1,11.2,18.7Z"/>
            <path d="M11.2,24.9V23.6c0-.2.1-.3.3-.5a1.445,1.445,0,0,1,.7-.2H33.3a1.445,1.445,0,0,1,.7.2.55.55,0,0,1,.3.5v1.3c0,.2-.1.3-.3.5a1.445,1.445,0,0,1-.7.2H12.2a1.445,1.445,0,0,1-.7-.2C11.3,25.2,11.2,25.1,11.2,24.9Z"/>
        </g>
    </svg>
</template>

<script>
    export default { name: "MenuIcon" }
</script>
